import { combineData, externalData, type ObservableValue } from '@amazon/vinyl-observable'
import { arePodcastsAvailable$ } from '@/customer/podcastsAvailable'
import { canAccessAudiobooks$, canAccessPodcastsAndAudiobooks$ } from '@/header/childProfileNavGate'
import { onNavigate } from '@/router/router'

export function podcastsNavVisible$(): ObservableValue<boolean> {
    return combineData({
        allowed: canAccessPodcastsAndAudiobooks$,
        available: arePodcastsAvailable$,
    }).map(({ allowed, available }) => allowed && available)
}

const inMusicSection$ = externalData<boolean>(
    typeof location !== 'undefined' && location.pathname.startsWith('/music'),
    (setData) => onNavigate((event) => setData(event.current.startsWith('/music')))
)

/**
 * GH hides the Music tab when no other content facet is offered, since Browse Home is then
 * already all music; it stays on the Music section itself. Podcasts count by territory alone, as
 * the child-profile gate resolves lazily and would flash the tab away on every load.
 */
export function musicNavVisible$(): ObservableValue<boolean> {
    return combineData({
        inMusic: inMusicSection$,
        audiobooks: canAccessAudiobooks$,
        podcasts: arePodcastsAvailable$,
    }).map(({ inMusic, audiobooks, podcasts }) => inMusic || audiobooks || podcasts)
}
